import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

import buttonClasses from '../ui/buttonClasses'

// Entry point to /best-ai-productivity-tools, the guide that features every
// affiliate-enrolled tool. Heading on the left, the four job groups on the
// right as one hairline grid: each cell deep-links to its section in the guide.
//
// Group names and tool lists mirror the guide's own sections.
const GROUPS = [
  {
    id: 'writing-research',
    title: 'Writing and research',
    job: 'Papers, citations, dense PDFs',
    tools: ['Jenni AI', 'Paperpal', 'SciSpace'],
  },
  {
    id: 'meetings-planning',
    title: 'Meetings and tasks',
    job: 'Notes, scheduling, group projects',
    tools: ['Circleback', 'Cal.com', 'Superlist', 'Taskade'],
  },
  {
    id: 'agents-voice',
    title: 'Agents, voice and video',
    job: 'Decks, dictation, voice-overs',
    tools: ['Runable', 'VoiceOS', 'ElevenLabs', 'Synthesia'],
  },
  {
    id: 'publish-grow',
    title: 'Publishing',
    job: 'A newsletter or side-project audience',
    tools: ['beehiiv', 'Postiz'],
  },
]

export default function ProductivityGuideFeature() {
  return (
    <section id="productivity-guide" className="py-14 md:py-24">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-10 px-5 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-16">
        <div className="lg:pt-2">
          <h2 className="t-h2 max-w-[18ch]">
            <span className="block text-muted">Free AI productivity tools,</span>
            <span className="block">grouped by the job</span>
          </h2>
          <p className="t-lede mt-4 max-w-[44ch]">
            Thirteen tools across writing, meetings, tasks, voice and publishing. Each has a free
            tier or trial and a line on who it suits.
          </p>
          <Link
            to="/best-ai-productivity-tools"
            className={buttonClasses({ variant: 'dark', size: 'lg', className: 'group mt-7' })}
          >
            Read the guide
            <ArrowRight
              className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
              aria-hidden="true"
            />
          </Link>
        </div>

        <ul className="grid grid-cols-1 gap-px overflow-hidden rounded-token-lg border border-line bg-line sm:grid-cols-2">
          {GROUPS.map((g) => (
            <li key={g.id} className="bg-bg-elev">
              <Link
                to={`/best-ai-productivity-tools#${g.id}`}
                className="group flex h-full flex-col p-5 transition-colors hover:bg-bg-sunk md:p-6"
              >
                <span className="flex items-start justify-between gap-3">
                  <span className="t-h3">{g.title}</span>
                  <ArrowRight
                    className="mt-1 h-4 w-4 shrink-0 text-muted-2 transition-all group-hover:translate-x-0.5 group-hover:text-ink"
                    aria-hidden="true"
                  />
                </span>
                <span className="mt-1 text-sm text-muted">{g.job}</span>
                <span className="mt-4 flex flex-wrap gap-1.5">
                  {g.tools.map((t) => (
                    <span
                      key={t}
                      className="rounded-full border border-line bg-bg px-2.5 py-1 text-xs font-medium text-ink-2"
                    >
                      {t}
                    </span>
                  ))}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
